<template>
  <div style="padding: 0;">
    <!--左侧组织-->
    <div class="col_1 w540 left_height">
      <div style="padding-top: 20px;">
        <ul class="tabs">
          <li v-for="item in tabsData" :key="item.name" v-if="item.available" class="tabs-item" @click="current=item;">
            <a href="javascript:;" :class="[current==item ? 'current': '']">{{item.tabName}}</a>
          </li>
        </ul>
        <div class="tab_content" style="min-height: 218px;">
          <!--Async :data="current" v-if="current"></Async-->
          <div v-if="current.name == 'org'">
            <!--tab1></tab1-->
            <div class="tab_content_semi" style="overflow: scroll; height: 218px;">
              <TreeView :model="treemenu" @node-clicked="nodeClicked" :options="options"></TreeView>
            </div><!-- gap elimanated
              --><div class="tab_content_semi">
            <div class="col_2 right_height" style="overflow: scroll; width: 100%; height: 218px; margin-top: 0; box-sizing: border-box;">
              <dl>
                <dt>可选人员列表</dt>
                <dd class="right_content" style="overflow-y: hidden;" v-if="currentPeople.length > 0">
                  <p v-for="item in currentPeople" :key="item.id">
                    <a href="javascript:void(0);" class="right_content_a">
                      {{item.name}}
                      <input type="checkbox" class="actions-select" :class="{'focus': item.selected }" @click="clickEffects($event);itemChecked($event.target.checked, item)" v-model="item.selected" />
                    </a>
                  </p>
                </dd>
                <h5 class="none_ts" v-else>
                  <img src="@/assets/images/none_data.jpg" alt="">
                </h5>
              </dl>
            </div>
          </div>
          </div>
          <div v-if="current.name == 'user'">
            <div class="col_2 right_height" style="overflow: scroll; width: 100%; height: 218px; margin-top: 0; box-sizing: border-box;">
              <dl>
                <dd class="right_content" style="overflow-y: hidden;" v-if="currentUsers.length > 0">
                  <p v-for="item in currentUsers" :key="item.id">
                    <a href="javascript:void(0);" class="right_content_a">
                      {{item.name}}
                      <input type="checkbox" class="actions-select" :class="{'focus': item.selected }" @click="clickEffects($event);itemChecked($event.target.checked, item)" v-model="item.selected" />
                    </a>
                  </p>
                </dd>
                <h5 class="none_ts" v-else>
                  <img src="@/assets/images/none_data.jpg" alt="">
                </h5>
              </dl>
            </div>
          </div>
          <div v-if="current.name == 'role'">
            <div class="col_2 right_height" style="overflow: scroll; width: 100%; height: 218px; margin-top: 0; box-sizing: border-box;">
              <dl>
                <dd class="right_content" style="overflow-y: hidden;" v-if="currentRoles.length > 0">
                  <p v-for="item in currentRoles" :key="item.id">
                    <a href="javascript:void(0);" class="right_content_a">
                      {{item.name}}
                      <input type="checkbox" class="actions-select" :class="{'focus': item.selected }" @click="clickEffects($event);itemChecked($event.target.checked, item)" v-model="item.selected" />
                    </a>
                  </p>
                </dd>
                <h5 class="none_ts" v-else>
                  <img src="@/assets/images/none_data.jpg" alt="">
                </h5>
              </dl>
            </div>
          </div>
        </div>
        <div class="right_height" style="height:218px; margin-top: 0; border-left: 0; padding-left: 0;">
          <dl>
            <dt style="margin-bottom: 0; font-weight: 900;">已选择的部门/人员/用户/角色<a href="javascript:void(0);" class="emptyBtn" @click="clear()">清空</a></dt>
            <dd class="right_content" style="overflow-y: scroll; height: 180px;">
              <p class="horizontal" :class="{ '': (item.type === '03' || item.type === '04'), 'bumeng-icon': !item.type }" v-for="item in outputs.people" :key="item.id">
                <a href="javascript:void(0);" class="right_content_a">
                  {{item.name}}
                  <span @click="del(item)"></span>
                </a>
              </p>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <!--/左侧组织-->
    <!--右侧已选组织和人员-->
    <div class="col_2 w365 right_height" style="height:445px;">
      <TagPicker :data="outputs.tags"></TagPicker>
    </div>
    <!--/右侧已选组织和人员-->
    <!--/右侧已选组织和人员-->
    <div class="clear"></div>
  </div>
</template>

<script>
  import TagPicker from '@/components/byl/tagPicker/index.vue'
  import TreeView  from '@/components/common/treeview/index.vue'
  import utils from '@/utils'
  import difference from 'lodash.differenceby'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: { TreeView, TagPicker },
    created () {
      this.initData()
      this.getUsers() // 异步获取用户信息
      this.getRoles()
      if (this.params.inputs) {
        this.outputs.people = this.params.inputs
      }
      if (this.params.treeViewOptions) {
        this.options = this.params.treeViewOptions
      }
      if (this.params.tabs) {
        for (let i = 0; i < this.params.tabs.length; i++) {
          var availables = this.params.tabs[i]
          for (let i = 0; i < this.tabsData.length; i++) {
            if (this.tabsData[i].name == availables) {
              this.tabsData[i].available = true
              this.current = this.tabsData[i]
            } else {
              this.tabsData[i].available = false
            }
          }
        }
      } else {
        this.current = this.tabsData[0]
      }
    },
    mounted () {
    },
    watch: {
      getCurrentRoles (val) {
        this.currentRoles = val
        for (let i = 0; i < this.currentRoles.length; i++) {
          var o = this.currentRoles[i]
          o.type = '05'  // 角色
        }
        let d = this.outputs.people.filter((val) => {
          return val.type == '05'
        })
        for (let i = 0; i < d.length; i++) {
          let idx = utils.findElem(this.currentRoles, 'id', d[i].id)
          this.currentRoles[idx].selected = true
        }
      },
      getCurrentUsers (val) {
        this.currentUsers = val
        for (let i = 0; i < this.currentUsers.length; i++) {
          var o = this.currentUsers[i]
          if (o.username) {
            o.name = o.username
          } else { // 没有用户名，用accountNames, 账户是肯定有的
            o.name = o.accountNames[0]
          }
          o.type = '04'  // 用户
        }
        let d = this.outputs.people.filter((val) => {
          return val.type == '04'
        })
        for (let i = 0; i < d.length; i++) {
          let idx = utils.findElem(this.currentUsers, 'id', d[i].id)
          this.currentUsers[idx].selected = true
        }
      },
      getCurrentDepts (val) { // 异步获取到的所有部门数据需要用watch
        this.treemenu = val
        // this.$set(this, 'treemenu', val) // 对象新增属性需要这么写
        if (this.currentPeople && this.currentPeople.length > 0) { // 为了刷新人员选中状态
          utils.setVal(this.currentPeople, 'selected', false)
        }
        // if (this.options.selectedNodes && this.options.selectedNodes.length > 0) { // 为了刷新树形结构中的部门选中状态
        this.options.selectedNodes = this.outputs.people.filter((val) => {
          return val.type !== '03'
        })
        // }
      },
      getCurrentList (val) { // 异步获取到的所有部门下面的人员数据需要用watch
        this.currentPeople = val
        utils.setVal(this.currentPeople, 'type', '03')
        let d = this.outputs.people.filter((val) => {
          return val.type == '03'
        })
        for (let i = 0; i < d.length; i++) {
          let idx = utils.findElem(this.currentPeople, 'id', d[i].id)
          this.currentPeople[idx].selected = true
        }
      }
    },
    computed: {
      ...mapState('orgstructure', ['menus', 'dept', 'list']),
      ...mapGetters('orgstructure', ['getCurrentList', 'getCurrentDepts', 'getCurrentDept']),
      ...mapGetters('users', ['getCurrentUsers', 'getCurrentRoles'])
    },
    props: ['params'],
    data () {
      var that = this
      return {
        current: {},
        currentSelects: [], // 外部传入的选中项
        options: {
          parentNodeClickable: true, //  点击有子菜单的node是否可以发出事件
          multiselect: true, // 是否允许多选
          editMode: false, // 是否允许编辑/删除
          searchMode: false, // 是否提供过滤
          semiCheck: false, // 是否提供全选（选中父级则勾选中所有子级）
          nodeSelected: function (check, val) { // checkbox选中后的回调 check: checkbox是否被选中 val：节点的值
            if (val) {
              if (this.semiCheck && val.children) {
                var r = []
                r.push(val) // 要将点击的节点(自己)加入数组
                var result = utils.flattern(val.children) // 将数组里的children取出来拉平
                if (check) {
                  if (that.outputs.people && that.outputs.people.length > 0) { // 原来就有值
                    that.outputs.people = that.outputs.people.concat(r.concat(result))
                  } else {
                    that.outputs.people = r.concat(result)
                  }
                } else {
                  that.outputs.people = difference(that.outputs.people, r.concat(result), 'id')  // 求差集
                }
              } else { // 没有children的节点被点中
                that.itemChecked(check, val)
              }
            }
          },
          selectedNodes: that.params.inputs // 选中的节点，一般用于初始化
        },
        treemenu: [],
        currentPeople: [],
        currentUsers: [], // 所有用户
        currentRoles: [],
        tabsData: [
          {
            name: 'org',
            tabName: '按组织架构',
            path: 'page/byl/org/plan/model.vue',
            available: true
          },
          {
            name: 'user',
            tabName: '按注册用户',
            path: 'page/be',
            available: false
          },
          {
            name: 'role',
            tabName: '按角色',
            path: 'page/be',
            available: false
          }
        ],
        outputs: {
          people: [], // 选择的人
          tags: [] // 标签
        }
      }
    },
    methods: {
      ...mapActions('orgstructure', ['getDepts', 'addDept', 'delDept', 'getPersonByDept', 'setDept', 'addPerson']),
      ...mapActions('users', ['getUsers', 'getRoles']),
      initData () {
        this.getDepts().then((r) => { // 异步获取部门信息 之后会默认去取部门下的人员
          if (r) {
            this.getPersonByDept({id: r[0].id})
          }
        })
      },
      clickEffects (e) {
        var $elem = $(e.target)
        if ($elem.is('input')) {
          $elem.toggleClass('focus')
        }
      },
      itemChecked (check, item) {
        console.log(item)
        var idIndex = utils.findElem(this.outputs.people, 'id', item.id)
        if (check) {
          if (idIndex > -1) { /* 已存在的item不能再添加了 */
            return false;
          } else {
            this.outputs.people.push(item)
          }
        } else {
          this.outputs.people.splice(idIndex, 1)
        }
      },
      nodeClicked (node) { // 获取部门下面的人员
        this.setDept(node)
        this.getPersonByDept({ id: node.id })
      },
      clear () {
        this.outputs.people = [];
        this.options.selectedNodes = [];
        this.initData()
      },
      del (item) {
        var idx = utils.findElem(this.outputs.people, 'id', item.id)
        var t = item.type
        this.outputs.people.splice(idx, 1)
        if (t == '03') { // 更新人员选中状态
          var idx1 = utils.findElem(this.currentPeople, 'id', item.id)
          this.currentPeople[idx1].selected = false
        } else if (t == '04') { // 更新用户选中状态
          var idx2 = utils.findElem(this.currentUsers, 'id', item.id)
          this.currentUsers[idx2].selected = false
        } else if (t == '05') { // 更新角色选中状态
          var idx3 = utils.findElem(this.currentRoles, 'id', item.id)
          this.currentRoles[idx3].selected = false
        } else { // 更新部门选中状态
          this.initData()
        }
      }
    }
  }
</script>

<style scoped>
  .right_content_a { width: 100%; text-align: left; text-decoration: none; color: black; }
  .tabs {
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    list-style: none;
    border-bottom: 1px solid #e3e3e3;
  }
  .tabs .tabs-item {
    float: left;
    height: 30px;
    line-height: 30px;
    color: #b1b1b1;
    width: 120px;
    text-align: center;
    padding: 0px;
    margin-right: 5px;
    padding-right: 5px;
  }
  .tabs .tabs-item a {
    float: left;
    position: relative;
    padding: 0 2px;
    height: 30px;
    line-height: 30px;
    text-transform: uppercase;
    text-decoration: none;
    color: #000;
    font-size: 14px;
    display: block;
    width: 100%;
    border: 1px solid #acacac;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .tabs .tabs-item a.current {
    z-index: 3;
    color: #fff;
    border-bottom: 2px solid #ff3633;
    background: #666666;
  }
  .tab_content .tab_content_semi {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }
  .actions-select {
    position: relative;
    top: 5px;
    float: right;
    background: url(images/reg_choose_icon_a@2x.png) center 0px no-repeat;
    opacity: 1;
    border: 1px solid #000;
    margin-right: 4px;
    -webkit-appearance: none;
    appearance: none;
    -moz-appearance: none;
    width: 18px;
    height: 18px;
    border: 0;
    vertical-align: middle;
    cursor: pointer;
  }
  .actions-select.focus {background: url(images/reg_choose_icon_c@2x.png) center 0px no-repeat;}
  .right_height dd p {
    height: 30px;
    line-height: 30px;
    background: url('images/header_list_icon@2x.png') left 7px no-repeat;
    padding-left: 20px;
  }
  .right_height dd p.horizontal {
    display: inline-block;
  }
  .right_height dd p.bumeng-icon {
    background: url('images/bumen_icon.png') left 7px no-repeat
  }
  .right_height dd p.wangwei-icon {
    background: url('images/wangwei_icon.png') left 7px no-repeat
  }
  .right_height dd p a { background: none; }
  .right_height dd p a span {
    display: block;
    float: right;
    width: 30px;
    height: 30px;
    background: url('images/header_list_clear@2x.png') right 7px no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/tagPicker/withTree.vue